import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../../../../data/blogPosts';
import './RelatedPosts.css';

const RelatedPosts = ({ currentPost }) => {
  // Get related posts from same category
  const relatedPosts = blogPosts
    .filter(post => 
      post.id !== currentPost.id && 
      post.category === currentPost.category
    )
    .slice(0, 3);

  // If not enough posts in same category, add from other categories
  if (relatedPosts.length < 3) {
    const additionalPosts = blogPosts
      .filter(post => 
        post.id !== currentPost.id && 
        !relatedPosts.includes(post)
      )
      .slice(0, 3 - relatedPosts.length);
    
    relatedPosts.push(...additionalPosts);
  }

  if (relatedPosts.length === 0) return null;

  return (
    <div className="related-posts">
      <h2 className="related-posts-title">You Might Also Like</h2>
      <div className="related-posts-grid">
        {relatedPosts.map(post => (
          <Link 
            key={post.id}
            to={`/blog/${post.slug}`}
            className="related-post-card"
          >
            <img 
              src={post.featuredImage} 
              alt={post.title}
              className="related-post-image"
            />
            <div className="related-post-content">
              <span className="related-post-category">{post.category}</span>
              <h3 className="related-post-title">{post.title}</h3>
              <p className="related-post-excerpt">{post.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedPosts;